import { render, staticRenderFns } from "./McHistogramChart.vue?vue&type=template&id=49b45664&"
import script from "./McHistogramChart.vue?vue&type=script&lang=js&"
export * from "./McHistogramChart.vue?vue&type=script&lang=js&"
import style0 from "./McHistogramChart.vue?vue&type=style&index=0&id=49b45664&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports